import moment from "moment"
import { Line_CHART_CATEGORY } from "src/blitz/Charts/constants"

export const roundTime = (date, interval) => {
  const momentDate = moment(date)
  
  // Handle day intervals (e.g., "1d", "2d", "7d")
  const dayMatch = interval.match(/^(\d+)d$/)
  if (dayMatch) {
    const days = parseInt(dayMatch[1], 10)
    const currentDayOfInterval = Math.floor(momentDate.dayOfYear() / days)
    const roundedDay = currentDayOfInterval * days
    
    return momentDate.hour() < 12
      ? momentDate.startOf("year").add(roundedDay, "days")
      : momentDate.startOf("year").add(roundedDay + days, "days")
  }
  
  // Handle hour intervals (e.g., "1h", "2h", "6h", "12h")
  const hourMatch = interval.match(/^(\d+)h$/)
  if (hourMatch) {
    const hours = parseInt(hourMatch[1], 10)
    return momentDate
      .hours(Math.round(momentDate.hours() / hours) * hours)
      .minutes(0)
      .seconds(0)
  }
  
  // Handle minute intervals (e.g., "5m", "15m", "30m", etc.)
  const minuteMatch = interval.match(/^(\d+)m$/)
  if (minuteMatch) {
    const minutes = parseInt(minuteMatch[1], 10)
    return momentDate
      .minutes(Math.round(momentDate.minutes() / minutes) * minutes)
      .seconds(0)
  }
  
  // Default fallback to 15 minutes if interval format is not recognized
  return momentDate
    .minutes(Math.round(momentDate.minutes() / 15) * 15)
    .seconds(0)
}

export const checkWithInRange = (chartCategory, range = [], value) => {
  if (chartCategory === Line_CHART_CATEGORY) {
    const min = range[0]
    const max = range[1]
    return value >= min && value <= max
  } else {
    return true
  }
}
